import { notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { readCommissionServicePage, readCommissionsPage } from "./commissions.server";
import { readCommissionRequestPage } from "./commission-request.server";
import { siteContext } from "./site.server";

/** Commissions (/commissions), for a site whose commissions are released to visitors. */
export const loadCommissions = createServerFn({ method: "GET" }).handler(async ({ context }) =>
  readCommissionsPage(await siteContext(context)),
);

/** One service (/commissions/:slug). */
export const loadCommissionService = createServerFn({ method: "GET" })
  .validator((slug: unknown) => {
    if (typeof slug !== "string" || !/^[a-z0-9-]{1,60}$/.test(slug)) throw notFound();
    return slug;
  })
  .handler(async ({ data: slug, context }) =>
    readCommissionServicePage(await siteContext(context), slug),
  );

/** A client's request, with the token from its private link. */
export const loadCommissionRequest = createServerFn({ method: "GET" })
  .validator((input: unknown) => {
    const { id, k } = (input ?? {}) as { id?: unknown; k?: unknown };
    if (typeof id !== "string" || !/^[\w-]{1,64}$/.test(id) || typeof k !== "string" || !k)
      throw notFound();
    return { id, k: k.slice(0, 200) };
  })
  .handler(async ({ data, context }) =>
    readCommissionRequestPage(await siteContext(context), data.id, data.k),
  );
